import * as React from 'react';
import Urls from '@/config/url';
import https from '@/utils/ajaxUtils';
import {
  Tabs, Pagination, message, DatePicker, Popover,
  Modal, Form, Input, Table, Tag,
} from 'antd';
import moment from 'moment';
import './index.css';

const { RangePicker } = DatePicker;
const { TabPane } = Tabs;

class Report extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentWorkPage: 1,
      workpageSize: 10,
      worktotal: 0,
      WorkReports: [],
      AllcurrentPage: 1,
      AllpageSize: 10,
      Alltotal: 0,
      AllReports: [],
      serchParam: {}
    };
  }
  filterform = React.createRef();
  componentWillMount() {
    console.log('this.props.location', this.props.location)//传递过来的所有参数
    // console.log(this.props.location.state.key值)//val值
    this.getReportWorkingPageList();
    this.getReportAllPageList();
  }
  // 获取报告(待完成)
  getReportWorkingPageList = async () => {
    let param = {
      currentPage: this.state.currentWorkPage,
      pageSize: this.state.workpageSize,
      state: 'working'
    }
    const res = await https.get(Urls.getReportPageList, param);
    console.log('获取报告(待完成): ', res);
    if (!res.success) {
      message.error('获取待完成报告失败');
      return;
    }
    this.setState({ WorkReports: res.data.data, worktotal: res.data.total });
  }
  // 获取报告(全部)
  getReportAllPageList = async () => {
    let param = {
      currentPage: this.state.AllcurrentPage,
      pageSize: this.state.AllpageSize,
      // state: 'working'
    }
    if (this.state.serchParam) {
      if (this.state.serchParam.fuzzyKeyword) {
        param.fuzzyKeyword = this.state.serchParam.fuzzyKeyword;
      }
      if (this.state.serchParam.time && this.state.serchParam.time.length > 0) {
        param.minCreateTime = moment(this.state.serchParam.time[0]).format('yyyy-MM-DD HH:mm:ss:SSS');
        param.maxCreateTime = moment(this.state.serchParam.time[1]).format('yyyy-MM-DD HH:mm:ss:SSS');
      }
    }
    const res = await https.get(Urls.getReportPageList, param);
    console.log('获取报告全部: ', res);
    if (!res.success) {
      message.error('获取报告失败');
      return;
    }
    this.setState({ AllReports: res.data.data, Alltotal: res.data.total });
  }
  resetForm = () => {
    this.filterform.current.resetFields();
  }
  filter = () => {
    // console.log(values);
    // this.setState({ AllcurrentPage: 1, serchParam: values }, () => {
    //   this.getReportAllPageList();
    // });
    this.filterform.current.validateFields().then((values) => {
      console.log('values: ', values);
      this.setState({ AllcurrentPage: 1, serchParam: values }, () => {
        this.getReportAllPageList();
      });

    }).catch(errorInfo => {
      // error
      // message.error('校验有误!');
    });
  }

  toResult = (data) => {
    console.log('data: ', data);
    if (data.state === 'done') {
      this.props.history.push({ pathname: "/service/result", state: { id: data.id, type: 'report' } });
    } else {
      Modal.warning({
        title: `预计出报告时间${this.getEstimate(data.createTime)}`,
        // content: 'some messages...some messages...',
      });
    }
  }
  // 获取预计耗时
  getEstimate = (time) => {
    if (!time) {
      return '-';
    }
    let endTime = new Date();
    endTime = moment(endTime);
    // console.log('endTime: ', endTime.format('yyyy-MM-DD HH:mm:ss'));
    let startTime = moment(time);
    // console.log('startTime: ', startTime.format('yyyy-MM-DD HH:mm:ss'));
    let estimate = endTime.diff(startTime, 'days');
    const h = estimate * 24; //相差的小时数
    const needTime = 24; // 24小时
    return (needTime - h > 0 ?  needTime - h : 0) + '小时';
  }
  render() {
    const changeWorkPage = (page) => {
      console.log('page: ', page);
      this.setState({
        currentWorkPage: page
      }, () => {
        this.getReportWorkingPageList();
      });
    };
    const changeWorkPageSize = (current, size) => {
      console.log('size: ', size);
      console.log('current: ', current);
      this.setState({
        currentWorkPage: current,
        workpageSize: size
      }, () => {
        this.getReportWorkingPageList();
      });
    };
    const changeAllPage = (page) => {
      console.log('page: ', page);
      this.setState({
        AllcurrentPage: page
      }, () => {
        this.getReportAllPageList();
      });
    };
    const changeAllPageSize = (current, size) => {
      console.log('size: ', size);
      console.log('current: ', current);
      this.setState({
        AllcurrentPage: current,
        AllpageSize: size
      }, () => {
        this.getReportAllPageList();
      });
    };

    const columns = [
      {
        title: '序号',
        dataIndex: 'num',
        key: 'num',
        width: 80,
        render: (text, rec, index) => {
          return ((this.state.AllcurrentPage - 1) * this.state.AllpageSize) + index + 1;
        }
      },
      {
        title: '关键词',
        dataIndex: 'keyword',
        key: 'keyword',
        width: 100,
      },
      {
        title: '一句话概括',
        dataIndex: 'question',
        key: 'question',
        width: 120,
      },
      {
        title: '相关词语',
        dataIndex: 'relativeWords',
        key: 'relativeWords',
        // ellipsis: true,
        width: 100,
      },
      {
        title: '搜索时间',
        dataIndex: 'createTime',
        key: 'createTime',
        width: 150,
        render: (text) => {
          if (!text) { return null; }
          if (text) {
            return moment(text).format('YYYY-MM-DD HH:mm:ss');
          }
        }
      },
      {
        title: '报告状态',
        dataIndex: 'state',
        key: 'state',
        width: 100,
        render: (text) => {
          if (!text) { return null; }
          if (text && text === 'working') {
            return <Tag color="gold">生成中</Tag>
          }
          if (text && text === 'done') {
            return <Tag color="green">已生成</Tag>
          }
        }
      },
      {
        title: '操作',
        dataIndex: 'actions',
        key: 'actions',
        // fixed: 'right',
        width: 70,
        render: (text, record) => {
          return (
            <div className="table-button">
              <a onClick={() => { this.toResult(record) }}>详情</a>
            </div>
          );
        }
      },
    ];
    const getKeyWords = (keyword) => {
      return (
        <div>
          <p>{keyword}</p>
        </div>
      );
    }
    return (
      <React.Fragment>
        <div className="top-img">
          <img src="/img/report-top-img.png" alt="" />
        </div>
        <div className="index-content">
          <div className="report-center">
            <Tabs onChange={this.tabChange} activeKey={this.state.activeKey}>
              <TabPane tab="待完成报告" key="1">
                <div className="table-container" style={{ height: '5.4rem' }}>
                  <div className="box-rep">
                    {
                      this.state.WorkReports && this.state.WorkReports.length > 0 &&
                      this.state.WorkReports.map((v) => {
                        return (
                          <div className="report" key={v.id}>
                            <img src="/img/report.jpg" className="logo-bj" alt=""></img>
                            <div className="rep-box">
                              <Popover
                                content={getKeyWords(v.keyword)}
                                title=""
                                overlayClassName="report-popover"
                              >
                                <div className="text">关键词：{v.keyword}</div>
                              </Popover>
                              <div className="box-box">
                                <div className="text">
                                  预计耗时：
                                  <span style={{ color: '#FF8909' }}>{this.getEstimate(v.createTime)}</span>
                                </div>
                                {/* <div className="txt">{this.getEstimate(v.finishTime)}</div> */}
                              </div>
                            </div>
                          </div>
                        );
                      })
                    }
                  </div>
                </div>
                <div style={{ height: 25, textAlign: 'right', marginTop: 10, marginRight: '0.3rem' }}>
                  <Pagination
                    size={'small'}
                    total={this.state.worktotal}
                    showQuickJumper={true}
                    // showSizeChanger={true}
                    current={this.state.currentWorkPage}
                    pageSize={this.state.workpageSize}
                    onChange={changeWorkPage}
                    onShowSizeChange={changeWorkPageSize}
                    showTotal={(total, range) => {
                      const totalPage = Math.ceil(total / this.state.workpageSize);
                      return '共 ' + total + ' 条数据，当前 ' + this.state.currentWorkPage + '/' + totalPage + '页';
                    }}
                  />
                </div>
              </TabPane>
              <TabPane tab="全部" key="2">
                <Form name="filter" ref={this.filterform} onFinish={this.filter} layout='inline' style={{ marginLeft: '0.2rem' }}>
                  {/* <Row className="filter-container" gutter={5}> */}
                  {/* <Col span={6}> */}
                  <Form.Item
                    label="关键词"
                    name="fuzzyKeyword"
                  >
                    <Input allowClear placeholder="请输入关键词模糊查询" style={{ width: '1.2rem' }} />
                  </Form.Item>
                  {/* </Col> */}
                  {/* <Col span={13}> */}
                  <Form.Item
                    label="搜索时间"
                    name="time"
                  >
                    {/* <Input allowClear placeholder="请输入权限名称模糊查询" /> */}
                    <RangePicker showTime allowClear style={{ width: '3.5rem' }} />
                  </Form.Item>
                  {/* </Col> */}
                  {/* <Col span={5}> */}
                  <Form.Item>
                    {/* <Space size={'large'}> */}
                    <div style={{ display: 'inline-flex' }}>
                      <div className="actionSelf" style={{ height: '0.4rem' }} onClick={this.filter} >
                        <div className="buttonSelf" style={{ minWidth: '0.8rem', height: '0.4rem', lineHeight: '0.4rem' }} >查询</div>
                      </div>
                      <div className="actionSelf" onClick={() => { this.resetForm() }} style={{ height: '0.3rem', marginLeft: '0.1rem' }}>
                        <div className="buttonSelf" style={{ minWidth: '0.8rem', height: '0.4rem', lineHeight: '0.4rem', background: 'linear-gradient(180deg, #bfbfbf  0%, #bfbfbf 100%)' }} >重置</div>
                      </div>
                    </div>
                    {/* </Space> */}
                  </Form.Item>
                  {/* </Col> */}
                  {/* </Row> */}
                </Form>
                <div className="table-container">
                  <Table
                    columns={columns}
                    bordered
                    dataSource={this.state.AllReports}
                    // scroll={{ y: '5rem' }}
                    rowKey={(record) => record.id}
                    pagination={{
                      showQuickJumper: true,
                      showSizeChanger: true,
                      onChange: changeAllPage,
                      onShowSizeChange: changeAllPageSize,
                      total: this.state.Alltotal,
                      current: this.state.AllcurrentPage,
                      pageSize: this.state.AllpageSize,
                      pageSizeOptions: ['10', '30', '50', '100'],
                      showTotal: (total, range) => {
                        // const totalPage = Math.ceil(total / this.state.AllpageSize);
                        return '共 ' + total + ' 条';
                      },
                    }} />
                </div>
              </TabPane>
            </Tabs>
          </div>
        </div>
      </React.Fragment >
    );
  }
}

export default Report;
